import {
  TeamOutlined,
  UserOutlined,
  ClockCircleOutlined,
  CalendarOutlined,
  CoffeeOutlined,
  IdcardOutlined,
  DollarOutlined,
  UserAddOutlined,
  ApartmentOutlined,
} from '@ant-design/icons';
import type { SidebarConfig } from './types';

export const hrSidebar: SidebarConfig = {
  module: 'hr',
  titleKey: 'common:nav.hr',
  icon: <TeamOutlined />,
  sections: [
    {
      key: 'people',
      labelKey: 'hr:sidebar.sections.people',
      items: [
        { key: 'employees', path: '/hr/employees', labelKey: 'hr:pages.employees', icon: <UserOutlined /> },
        { key: 'org-chart', path: '/hr/org-chart', labelKey: 'hr:pages.orgChart', icon: <ApartmentOutlined /> },
        { key: 'recruitment', path: '/hr/recruitment', labelKey: 'hr:pages.recruitment', icon: <UserAddOutlined /> },
      ],
    },
    {
      key: 'timeAndLeave',
      labelKey: 'hr:sidebar.sections.timeAndLeave',
      items: [
        { key: 'attendance', path: '/hr/attendance', labelKey: 'hr:pages.attendance', icon: <ClockCircleOutlined /> },
        { key: 'timesheets', path: '/hr/timesheets', labelKey: 'hr:pages.timesheets', icon: <CalendarOutlined /> },
        { key: 'leave', path: '/hr/leave', labelKey: 'hr:pages.leave', icon: <CoffeeOutlined /> },
      ],
    },
    {
      key: 'compliance',
      labelKey: 'hr:sidebar.sections.compliance',
      items: [
        { key: 'document-expiry', path: '/hr/document-expiry', labelKey: 'hr:pages.documentExpiry', icon: <IdcardOutlined /> },
        { key: 'payroll', path: '/hr/payroll', labelKey: 'hr:pages.payroll', icon: <DollarOutlined /> },
      ],
    },
  ],
};
